'use strict';

/**
 * Tab Item custom element.
 */
JQX('jqx-tab-item', function (_JQX$ContentElement) {
    babelHelpers.inherits(TabItem, _JQX$ContentElement);

    function TabItem() {
        babelHelpers.classCallCheck(this, TabItem);
        return babelHelpers.possibleConstructorReturn(this, (TabItem.__proto__ || Object.getPrototypeOf(TabItem)).apply(this, arguments));
    }

    babelHelpers.createClass(TabItem, [{
        key: 'propertyChangedHandler',


        /**
         * Called when a property is changed.
         */
        value: function propertyChangedHandler(propertyName, oldValue, newValue) {
            babelHelpers.get(TabItem.prototype.__proto__ || Object.getPrototypeOf(TabItem.prototype), 'propertyChangedHandler', this).call(this, propertyName, oldValue, newValue);

            var that = this;

            if (that._preventPropertyChangedHandler) {
                delete that._preventPropertyChangedHandler;
                return;
            }

            switch (propertyName) {
                case 'closeButtonHidden':
                    that.$.fireEvent('closeButtonVisibilityChange', { 'hidden': newValue });
                    break;
                case 'index':
                    that.$.fireEvent('indexChange', { 'newIndex': newValue, 'oldIndex': oldValue, 'tabItem': that });
                    break;
                case 'selected':
                    if (newValue) {
                        that.$.removeClass('jqx-hidden');
                    } else {
                        that.$.addClass('jqx-hidden');
                    }

                    break;
                case 'label':
                    break;
                case 'labelSize':
                    that.$.fireEvent('labelSizeChange', { 'size': newValue });
                    break;
            }
        }

        /**
         * Sets the index without "propertyChangedHandler" being called
         */

    }, {
        key: '_setIndex',
        value: function _setIndex(index) {
            var that = this,
                oldContext = that.context;

            that.context = that;
            that.index = index;
            that.context = oldContext;
        }
    }], [{
        key: 'properties',

        // Tab Item's properties.
        get: function get() {
            return {
                'closeButtonHidden': {
                    value: false,
                    type: 'boolean'
                },
                'index': {
                    value: null,
                    type: 'number?'
                },
                'selected': {
                    value: false,
                    type: 'boolean'
                },
                'label': {
                    value: '',
                    type: 'string'
                },
                'labelSize': {
                    value: null,
                    type: 'number?'
                }
            };
        }
    }]);
    return TabItem;
}(JQX.ContentElement));

/**
 * Tab Items Group custom element.
 */
JQX('jqx-tab-items-group', function (_JQX$ContentElement2) {
    babelHelpers.inherits(TabItemsGroup, _JQX$ContentElement2);

    function TabItemsGroup() {
        babelHelpers.classCallCheck(this, TabItemsGroup);
        return babelHelpers.possibleConstructorReturn(this, (TabItemsGroup.__proto__ || Object.getPrototypeOf(TabItemsGroup)).apply(this, arguments));
    }

    babelHelpers.createClass(TabItemsGroup, [{
        key: 'template',


        /**
         * Tab Items Group's HTML template.
         */
        value: function template() {
            return '';
        }

        /**
         * Called when a property is changed.
         */

    }, {
        key: 'propertyChangedHandler',
        value: function propertyChangedHandler(propertyName, oldValue, newValue) {
            babelHelpers.get(TabItemsGroup.prototype.__proto__ || Object.getPrototypeOf(TabItemsGroup.prototype), 'propertyChangedHandler', this).call(this, propertyName, oldValue, newValue);

            var that = this;

            if (that._preventPropertyChangedHandler) {
                delete that._preventPropertyChangedHandler;
                return;
            }

            switch (propertyName) {
                case 'label':
                    break;
                case 'labelSize':
                    this.$.fireEvent('labelSizeChange', { 'size': newValue });
                    break;
            }
        }
    }], [{
        key: 'properties',

        // Tab Items Group's properties.
        get: function get() {
            return {
                'label': {
                    value: '',
                    type: 'string'
                },
                'labelSize': {
                    value: null,
                    type: 'number?'
                }
            };
        }
    }]);
    return TabItemsGroup;
}(JQX.ContentElement));

/**
 * Tabs custom element.
 */
JQX('jqx-tabs', function (_JQX$BaseElement) {
    babelHelpers.inherits(Tabs, _JQX$BaseElement);

    function Tabs() {
        babelHelpers.classCallCheck(this, Tabs);
        return babelHelpers.possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));
    }

    babelHelpers.createClass(Tabs, [{
        key: 'template',


        /**
         * Tabs's HTML template.
         */
        value: function template() {
            return '<div id="container">\n                    <div id="tabHeaderSection" class="jqx-tabs-header-section">\n                        <jqx-repeat-button initial-delay="0" delay="75" id="scrollButtonNear" class="jqx-tabs-scroll-button jqx-spin-button">\n                            <div id="arrowNear" class="jqx-arrow"></div>\n                        </jqx-repeat-button>\n                        <div id="tabStrip" class="jqx-tab-strip"></div>\n                        <jqx-repeat-button initial-delay="0" delay="75" id="scrollButtonFar" class="jqx-tabs-scroll-button jqx-spin-button">\n                            <div id="arrowFar" class="jqx-arrow"></div>\n                        </jqx-repeat-button>\n                        <div id="dropDownButton" class="jqx-tabs-dropdown-button">\n                            <div id="dropDownButtonArrow" class="jqx-tabs-dropdown-button-arrow jqx-unselectable"></div>\n                            <div id="dropDownButtonPopup" class="jqx-tabs-dropdown-button-popup jqx-hidden"></div>\n                        </div>\n                        <div id="resizeToken" class="jqx-tabs-resize-token jqx-hidden"></div>\n                    </div>\n                    <div id="tabContentSection" class="jqx-tabs-content-section"><content></content></div>\n                </div>';
        }

        /**
         * Called when the element is ready. Used for one-time configuration of the Tab.
         */

    }, {
        key: 'ready',
        value: function ready() {
            babelHelpers.get(Tabs.prototype.__proto__ || Object.getPrototypeOf(Tabs.prototype), 'ready', this).call(this);

            var that = this;

            that._firefox = navigator.userAgent.indexOf('Firefox') !== -1;
            that._arrowCodes = { top: '&#xe804', bottom: '&#xe801', left: '&#xe802', right: '&#xe803' };

            that._ensureItemsReady(that.querySelectorAll('jqx-tab-item, jqx-tab-items-group'), that._createElement.bind(that));
        }

        /**
         * Appends a "jqx-tab-item" node as the last tab of the Tabs.
         *
         * @param {HTMLElement} node The "jqx-tab-item" node to append.
         */

    }, {
        key: 'appendChild',
        value: function appendChild(node) {
            var that = this;

            if (!that.isCompleted || node instanceof HTMLElement && node.classList.contains('jqx-resize-trigger-container')) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.appendChild.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (!(node instanceof JQX.TabItem)) {
                that.error(that.localize('tabItemRequired', { method: 'appendChild' }));
            }

            that.insert(that._tabs.length, { node: node });
        }

        /**
         * Collapses the content section.
         */

    }, {
        key: 'collapse',
        value: function collapse() {
            var that = this;

            if (!that.collapsible || that.collapsed) {
                return;
            }

            that.collapsed = true;
        }

        /**
         * Makes sure a tab is visible by scrolling to it.
         *
         * @param {Number} index The index of the tab to scroll to.
         */

    }, {
        key: 'ensureVisible',
        value: function ensureVisible(index) {
            var that = this;

            if (index === null || that.tabOverflow === 'wrap' || that.tabOverflow === 'shrink' || that.position === 'hidden') {
                return;
            }

            that._validateIndex(index, 'ensureVisible');
            index = Math.max(0, Math.min(index, that._tabs.length - 1));

            var group = that._tabs[index].group,
                tabStrip = that.$.tabStrip,
                tabStripBoundingRect = tabStrip.getBoundingClientRect(),
                scrollTarget = group === null ? that._tabLabelContainers[index] : that._groupLabels[that._groups.indexOf(group)],
                scrollTargetBoundingRect = scrollTarget.getBoundingClientRect();

            if ((that.position === 'top' || that.position === 'bottom') && (tabStripBoundingRect.left > scrollTargetBoundingRect.left || tabStripBoundingRect.right < scrollTargetBoundingRect.right)) {
                tabStrip.scrollLeft += scrollTargetBoundingRect.right - tabStrip.offsetWidth - tabStripBoundingRect.left;
            } else if ((that.position === 'left' || that.position === 'right') && (tabStripBoundingRect.top > scrollTargetBoundingRect.top || tabStripBoundingRect.bottom < scrollTargetBoundingRect.bottom)) {
                tabStrip.scrollTop += scrollTargetBoundingRect.bottom - tabStrip.offsetHeight - tabStripBoundingRect.top;
            }

            if (that.resize) {
                that._getTabCoordinates();
            }
        }

        /**
         * Expands the content section.
         */

    }, {
        key: 'expand',
        value: function expand() {
            var that = this;

            if (!that.collapsible || !that.collapsed) {
                return;
            }

            that.collapsed = false;
        }

        /**
         * Inserts a new tab and an associated content section.
         *
         * @param {Number} index The index to insert a new tab at.
         * @param {Object} details An Object with the fields "label", "labelSize", "content" and "group".
         */

    }, {
        key: 'insert',
        value: function insert(index, details) {
            var that = this;
            var group = void 0,
                tab = void 0;

            that._validateIndex(index, 'insert');
            if (details === undefined || details.label === undefined && details.content === undefined && details.node === undefined) {
                that.error(that.localize('detailsObjectRequired'));
            }

            if (details.node === undefined) {
                group = details.group;
                tab = document.createElement('jqx-tab-item');

                tab.label = details.label !== undefined ? details.label : '';
                tab.labelSize = details.labelSize !== undefined ? details.labelSize : null;
                tab.content = details.content;
            } else {
                tab = details.node;
            }

            tab.$.addClass('jqx-hidden');

            tab.group = null;

            var labelContainers = that._addTabLabelContainer(tab),
                tabLabelContainer = labelContainers.tabLabelContainer,
                dropDownPopupLabelContainer = labelContainers.dropDownPopupLabelContainer;

            tabLabelContainer.tab = tab;
            tab.tabLabelContainer = tabLabelContainer;

            var tabDetails = { index: index, tab: tab, tabLabelContainer: tabLabelContainer, dropDownPopupLabelContainer: dropDownPopupLabelContainer };

            if (that._groups.length === 0 && group === undefined) {
                that._insertNoGrouping(tabDetails);
            } else {
                if (group !== undefined) {
                    tabDetails.group = group;
                    var jqxTabItemsGroup = that.$.tabContentSection.querySelector('jqx-tab-items-group[label="' + group + '"]');

                    if (jqxTabItemsGroup !== null) {
                        // group exists
                        tabDetails.jqxTabItemsGroup = jqxTabItemsGroup;
                        that._insertIntoExistingGroup(tabDetails);
                    } else {
                        // group does not exist
                        that._insertIntoNewGroup(tabDetails);
                    }
                } else {
                    that._insertNearAGroup(tabDetails);
                }
            }

            that._getReorderItems();

            if (that.selectedIndex === null && that._tabs.length) {
                that._select(0, false);
            }

            if (tab.group !== null && tab.labelSize !== null && that.tabOverflow !== 'shrink') {
                tabLabelContainer.style.removeProperty([that._orientationSettings.dimension]);
            }

            that._applyTabOverflow();
        }

        /**
         * Inserts the specified "jqx-tab-item" node before the reference "jqx-tab-item" node.
         *
         * @param {HTMLElement} newNode The "jqx-tab-item" node to insert.
         * @param {HTMLElement} referenceNode The "jqx-tab-item" node before which newNode is inserted.
         */

    }, {
        key: 'insertBefore',
        value: function insertBefore(newNode, referenceNode) {
            var that = this;

            if (!that.isCompleted) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.insertBefore.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (!(newNode instanceof JQX.TabItem) || referenceNode !== undefined && referenceNode !== null && !(referenceNode instanceof JQX.TabItem)) {
                that.error(that.localize('tabItemRequired', { method: 'insertBefore' }));
            }

            var reselectIndex = void 0;

            if (that.contains(newNode)) {
                if (newNode.selected) {
                    reselectIndex = true;
                }

                that.remove(newNode.index);
            }

            if (referenceNode !== undefined && referenceNode !== null) {
                if (!that.contains(referenceNode)) {
                    that.error(that.localize('referenceNodeNotChild', { argument: 'referenceNode' }));
                }

                that.insert(referenceNode.index, { node: newNode });
            } else {
                that.insert(that._tabs.length, { node: newNode });
            }

            if (reselectIndex) {
                that._select(newNode.index, false);
            }
        }

        /**
         * Removes a tab and its associated content section.
         *
         * @param {Number} index The index of the tab to remove.
         */

    }, {
        key: 'remove',
        value: function remove(index) {
            var that = this,
                initialNumberOfTabs = that._tabs.length;

            if (initialNumberOfTabs === 0) {
                return;
            }

            that._validateIndex(index, 'remove');

            index = Math.max(0, Math.min(index, initialNumberOfTabs - 1));

            var tab = that._tabs[index],
                tabLabelContainer = that._tabLabelContainers[index];

            tabLabelContainer.parentElement.removeChild(tabLabelContainer);
            tab.parentElement.removeChild(tab);

            if (tab.group !== null) {
                var jqxTabItemsGroup = that.$.tabContentSection.querySelector('jqx-tab-items-group[label="' + tab.group + '"]');

                if (jqxTabItemsGroup.childElementCount === 0) {
                    var groupIndex = that._groups.indexOf(tab.group);

                    that.$.tabStrip.removeChild(that._groupLabels[groupIndex]);

                    that._groups.splice(groupIndex, 1);
                    that._groupLabels.splice(groupIndex, 1);

                    that.$.tabContentSection.removeChild(jqxTabItemsGroup);
                }
            }

            if (initialNumberOfTabs > 1) {
                if (index < that.selectedIndex) {
                    that.selectedIndex--;
                } else if (index === that.selectedIndex) {
                    if (index === initialNumberOfTabs - 1) {
                        that._select(index - 1, false);
                    } else {
                        that._select(index + 1, false);
                        that.selectedIndex--;
                    }
                }
            } else {
                that.selectedIndex = null;
                that.$.tabContentSection.innerHTML = '';
            }

            that._tabLabelContainers.splice(index, 1);
            that.$.dropDownButtonPopup.removeChild(that.$.dropDownButtonPopup.children[index]);
            that._tabs.splice(index, 1);

            that._updateTabIndexes();
            that._getReorderItems();
            that._applyTabOverflow();
            that.ensureVisible(that.selectedIndex);
        }

        /**
         * Removes a child "jqx-tab-item" node.
         *
         * @param {HTMLElement} node The "jqx-tab-item" node to remove.
         */

    }, {
        key: 'removeChild',
        value: function removeChild(node) {
            var that = this;

            if (!that.isCompleted || node instanceof HTMLElement && node.classList.contains('jqx-resize-trigger-container')) {
                var args = Array.prototype.slice.call(arguments, 2);
                return HTMLElement.prototype.removeChild.apply(that, args.concat(Array.prototype.slice.call(arguments)));
            }

            if (!(node instanceof JQX.TabItem)) {
                that.error(that.localize('tabItemRequired', { method: 'removeChild' }));
            }

            if (!that.contains(node)) {
                that.error(that.localize('referenceNodeNotChild', { argument: 'node' }));
            }

            that.remove(node.index);
        }

        /**
         * Selects a tab.
         *
         * @param {Number} index The index of the tab to select.
         */

    }, {
        key: 'select',
        value: function select(index) {
            var that = this;

            if (that._tabs.length === 0) {
                return;
            }

            that._validateIndex(index, 'select');

            index = Math.max(0, Math.min(index, that._tabs.length - 1));

            that.ensureVisible(index);

            that._select(index, true);
        }

        /**
         * Sets whether the element can be focused.
         *
         * @param {Boolean} focusable Whether the element can be focused.
         */

    }, {
        key: 'setFocusable',
        value: function setFocusable(focusable) {
            var that = this;

            that._focusable = focusable;

            if (that.disabled || !that._focusable) {
                that.removeAttribute('tabindex');
                return;
            }

            if (that.tabIndex < 0) {
                that.tabIndex = 0;
            }
        }

        /**
         * Updates a tab and its associated content section.
         *
         * @param {Number} index The index of the tab to update.
         * @param {String} label The new label of the tab. The value can be the id of an HTMLTemplateElement.
         * @param {String/HTMLElement} content The new content of the tab.
         */

    }, {
        key: 'update',
        value: function update(index, label, content) {
            var that = this;

            if (that._tabs.length === 0) {
                return;
            }

            that._validateIndex(index, 'update');

            index = Math.max(0, Math.min(index, that._tabs.length - 1));

            var tab = that._tabs[index];

            if (label !== undefined && tab.label !== label) {
                var labelTextContainer = that._tabLabelContainers[index].children[0],
                    dropDownPopupLabelContainer = that.$.dropDownButtonPopup.children[index];

                tab.label = label;
                labelTextContainer.innerHTML = '';
                dropDownPopupLabelContainer.innerHTML = '';
                that._setLabel(label, labelTextContainer, dropDownPopupLabelContainer);

                that._applyTabOverflow();
            }

            if (content !== undefined) {
                tab.content = content;
            }
        }

        /**
         * Applies initial settings to the Tabs element.
         */

    }, {
        key: '_createElement',
        value: function _createElement() {
            var that = this,
                oldContext = that.context;

            that.context = that;

            that._handlePosition(that.position);
            that._handleScrollButtonsPosition(that.scrollButtonsPosition, 'both');

            that._getTabs();
            that._orderTabs();

            that.setFocusable(true);

            if (that.collapsed && !that.collapsible) {
                that.collapsed = false;
            }

            that._validateInitialSelection();
            that._populateTabStrip();

            if (that.addNewTab) {
                that._insertAddNewTab();
            }

            that._getReorderItems();

            that._applyTabOverflow();
            that.$.scrollButtonNear.firstElementChild.tabIndex = -1;
            that.$.scrollButtonFar.firstElementChild.tabIndex = -1;

            that.ensureVisible(that.selectedIndex);

            that.context = oldContext;
        }

        /**
         * Called when a property is changed.
         */

    }, {
        key: 'propertyChangedHandler',
        value: function propertyChangedHandler(propertyName, oldValue, newValue) {
            babelHelpers.get(Tabs.prototype.__proto__ || Object.getPrototypeOf(Tabs.prototype), 'propertyChangedHandler', this).call(this, propertyName, oldValue, newValue);

            var that = this;

            switch (propertyName) {
                case 'addNewTab':
                    if (newValue) {
                        that._insertAddNewTab();
                    } else {
                        that.$.tabStrip.removeChild(that._addNewTab);
                        delete that._addNewTab;
                    }

                    that._applyTabOverflow();
                    break;
                case 'closeButtonMode':
                    if (newValue === 'selected') {
                        for (var i = 0; i < that._tabs.length; i++) {
                            that._disableCloseButton(i);
                        }

                        that._enableCloseButton(that.selectedIndex);
                    } else {
                        that._disableCloseButton(that.selectedIndex);

                        var tabLabelContainers = that._tabLabelContainers;

                        for (var _i = 0; _i < tabLabelContainers.length; _i++) {
                            var tabLabelContainer = tabLabelContainers[_i];

                            tabLabelContainer.closeButtonEnabled = that._tabs[_i].closeButtonHidden !== true;
                            that._showCloseButton(tabLabelContainer);
                        }
                    }

                    that._applyTabOverflow();
                    break;
                case 'closeButtons':
                    {
                        var _tabLabelContainers = that._tabLabelContainers,
                            fn = newValue ? that._showCloseButton : that._hideCloseButton;

                        for (var _i2 = 0; _i2 < _tabLabelContainers.length; _i2++) {
                            var _tabLabelContainer = _tabLabelContainers[_i2];

                            fn(_tabLabelContainer);
                        }

                        that._applyTabOverflow();
                        break;
                    }
                case 'collapsed':
                    if (!that.collapsible && newValue) {
                        that.collapsed = false;
                        return;
                    }

                    break;
                case 'collapsible':
                    if (!newValue && that.collapsed) {
                        that.collapsed = false;
                    }

                    break;
                case 'disabled':
                    that.setFocusable(that._focusable === undefined ? true : that._focusable);
                    break;
                case 'messages':
                case 'selectionMode':
                case 'readonly':
                case 'reorder':
                    break;
                case 'position':
                    {
                        that._closeGroupPopup();
                        that._handlePosition(newValue, oldValue);

                        if (that.tabOverflow !== 'shrink') {
                            that._applyLabelSizes('position');
                        }

                        that._applyTabOverflow();

                        if (newValue !== 'hidden') {
                            var arrows = that.getElementsByClassName('jqx-tab-group-arrow');

                            for (var _i3 = 0; _i3 < arrows.length; _i3++) {
                                arrows[_i3].innerHTML = that._arrowCodes[that.position];
                            }
                        }

                        break;
                    }
                case 'resize':
                    if (newValue) {
                        that._getTabCoordinates();
                    }

                    break;
                case 'scrollButtonsPosition':
                    that._handleScrollButtonsPosition(newValue, oldValue);
                    break;
                case 'selectedIndex':
                    {
                        if (newValue === null) {
                            that.selectedIndex = oldValue;
                            return;
                        }

                        var validIndex = Math.max(0, Math.min(newValue, that._tabs.length - 1));

                        that.ensureVisible(validIndex);

                        that._select(validIndex, true, oldValue);
                        break;
                    }
                case 'tabOverflow':
                    if (oldValue === 'scroll') {
                        that.$tabHeaderSection.removeClass('scroll-buttons-shown');
                    }

                    if (newValue === 'shrink') {
                        that._applyLabelSizes('shrink', true);
                    } else if (oldValue === 'shrink') {
                        that._applyLabelSizes('shrink', false);
                    }

                    that._applyTabOverflow();
                    that.ensureVisible(that.selectedIndex);
                    break;
                case 'textOrientation':
                    that._applyTabOverflow();
                    that.ensureVisible(that.selectedIndex);
                    break;
            }
        }

        /**
         * Adds a tab group container.
         */

    }, {
        key: '_addGroupContainer',
        value: function _addGroupContainer(label, labelSize) {
            var that = this,
                groupContainer = document.createElement('div'),
                labelTextContainer = document.createElement('div'),
                arrow = document.createElement('div'),
                popup = document.createElement('div');

            groupContainer.className = 'jqx-tab-group-container jqx-unselectable';
            groupContainer.$ = JQX.Utilities.Extend(groupContainer);

            if (labelSize !== null && that.tabOverflow !== 'shrink') {
                groupContainer.style[that._orientationSettings.dimension] = parseInt(labelSize, 10) + 'px';
            }

            // label
            labelTextContainer.className = 'jqx-tab-label-text-container';
            labelTextContainer.innerHTML = label;

            // down arrow
            arrow.className = 'jqx-tab-group-arrow';
            arrow.innerHTML = that._arrowCodes[that.position];

            // pop-up
            popup.className = 'jqx-tab-group-popup jqx-hidden';
            popup.$ = JQX.Utilities.Extend(popup);

            groupContainer.appendChild(labelTextContainer);
            groupContainer.appendChild(arrow);
            that.$.container.appendChild(popup);

            groupContainer.group = label;
            groupContainer.popup = popup;
            popup.groupContainer = groupContainer;

            return { label: groupContainer, popup: popup };
        }

        /**
         * Adds group-related elements to the tabstrip.
         */

    }, {
        key: '_addGroupElements',
        value: function _addGroupElements(details) {
            var that = this,
                groups = details.groups,
                groupLabels = details.groupLabels,
                group = details.group,
                groupIndex = groups.indexOf(group),
                tabLabelContainer = details.tabLabelContainer;
            var groupLabel = void 0;

            if (groupIndex !== -1) {
                // group exists
                groupLabel = groupLabels[groupIndex];
                groupLabel.popup.appendChild(tabLabelContainer);
            } else {
                // group does not exist
                groups.push(group);

                var groupContainers = that._addGroupContainer(group, details.jqxTabItemsGroup.labelSize),
                    groupPopup = groupContainers.popup;

                groupLabel = groupContainers.label;

                groupPopup.appendChild(tabLabelContainer);
                details.documentFragment.appendChild(groupLabel);

                groupLabels.push(groupLabel);
            }

            if (that.selectedIndex === details.i) {
                that._selectedGroup = groupLabel;
                groupLabel.$.addClass('jqx-tab-group-selected');
            }
        }

        /**
         * "add new" tab event handler.
         */

    }, {
        key: '_addNewTabHandler',
        value: function _addNewTabHandler(currentElement, eventType, click) {
            var that = this;

            if (click) {
                currentElement.$.removeClass('jqx-tab-hovered');

                that.insert(that._tabs.length, { label: 'New Tab', content: '' });
                that._select(that._tabs.length - 1, true);
            } else if (!that._dragging) {
                if (eventType === 'mouseover') {
                    currentElement.$.addClass('jqx-tab-hovered');
                } else if (eventType === 'mouseout') {
                    currentElement.$.removeClass('jqx-tab-hovered');
                }
            }
        }

        /**
         * Adds a tab label container.
         */

    }, {
        key: '_addTabLabelContainer',
        value: function _addTabLabelContainer(tab, addNewTab) {
            var that = this,
                tabLabelContainer = document.createElement('div'),
                labelTextContainer = document.createElement('div'),
                closeButton = document.createElement('div');
            var dropDownPopupLabelContainer = void 0;

            tabLabelContainer.className = 'jqx-tab-label-container jqx-unselectable';

            // label
            labelTextContainer.className = 'jqx-tab-label-text-container';

            // close button
            closeButton.className = 'jqx-tab-close-button';
            closeButton.innerHTML = '×';

            if (addNewTab === undefined) {
                if (that.closeButtons) {
                    if (that.closeButtonMode === 'default' && tab.closeButtonHidden || that.closeButtonMode === 'selected' && !tab.selected) {
                        closeButton.classList.add('jqx-hidden');
                        tabLabelContainer.closeButtonEnabled = false;
                    } else {
                        labelTextContainer.classList.add('jqx-close-button-enabled');
                        tabLabelContainer.closeButtonEnabled = true;
                    }
                } else {
                    closeButton.classList.add('jqx-hidden');
                    tabLabelContainer.closeButtonEnabled = true;
                }

                dropDownPopupLabelContainer = document.createElement('div');
                dropDownPopupLabelContainer.className = 'jqx-tab-label-container jqx-unselectable';

                if (tab.group === null && tab.labelSize !== null && that.tabOverflow !== 'shrink') {
                    tabLabelContainer.style[that._orientationSettings.dimension] = parseInt(tab.labelSize, 10) + 'px';
                }
            } else {
                closeButton.classList.add('jqx-hidden');
                tabLabelContainer.closeButtonEnabled = false;
            }

            that._setLabel(tab ? tab.label : '+', labelTextContainer, dropDownPopupLabelContainer);

            labelTextContainer.$ = JQX.Utilities.Extend(labelTextContainer);
            closeButton.$ = JQX.Utilities.Extend(closeButton);

            tabLabelContainer.appendChild(labelTextContainer);
            tabLabelContainer.appendChild(closeButton);

            tabLabelContainer.$ = JQX.Utilities.Extend(tabLabelContainer);

            return { tabLabelContainer: tabLabelContainer, dropDownPopupLabelContainer: dropDownPopupLabelContainer };
        }

        /**
         * Shows or hides the scroll buttons.
         */

    }, {
        key: '_applyConditionalTabOverflow',
        value: function _applyConditionalTabOverflow() {
            var that = this,
                verticalPosition = that.position === 'left' || that.position === 'right',
                tabStrip = that.$.tabStrip;

            if (that.tabOverflow === 'scroll') {
                var tabHeaderSection = that.$tabHeaderSection;

                tabHeaderSection.removeClass('scroll-buttons-shown');

                if (!verticalPosition && tabStrip.scrollWidth > tabStrip.offsetWidth || verticalPosition && tabStrip.scrollHeight > tabStrip.offsetHeight) {
                    tabHeaderSection.addClass('scroll-buttons-shown');
                }

                return;
            }

            if (that._firefox && that.tabOverflow === 'shrink' && verticalPosition) {
                if (tabStrip.scrollHeight > tabStrip.offsetHeight) {
                    var tabStripChildren = tabStrip.children,
                        height = 100 / tabStripChildren.length + '%';

                    for (var i = 0; i < tabStripChildren.length; i++) {
                        tabStripChildren[i].style.height = height;
                        tabStripChildren[i].firstElementChild.classList.add('jqx-tab-label-text-container-full-height');
                    }

                    that._inlineStyleTabStripChildren = true;
                }
            }
        }

        /**
         * Applies label sizes.
         */

    }, {
        key: '_applyLabelSizes',
        value: function _applyLabelSizes(condition, removeLabelSize) {
            var that = this,
                newDimension = that._orientationSettings.dimension,
                oldDimension = newDimension === 'width' ? 'height' : 'width';

            for (var i = 0; i < that._reorderItems.length; i++) {
                var currentItem = that._reorderItems[i],
                    correspondingCustomElement = that._getCorrespondingCustomElement(currentItem);

                if (correspondingCustomElement.labelSize !== null) {
                    if (condition === 'position') {
                        currentItem.style.removeProperty(oldDimension);
                    }

                    if (!removeLabelSize) {
                        currentItem.style[newDimension] = parseInt(correspondingCustomElement.labelSize, 10) + 'px';
                    } else {
                        currentItem.style.removeProperty(newDimension);
                    }
                }
            }
        }

        /**
         * Applies the necessary adjustments in order to achieve the chosen tab overflow.
         */

    }, {
        key: '_applyTabOverflow',
        value: function _applyTabOverflow() {
            var that = this,
                tabOverflow = that.tabOverflow,
                position = that.position,
                verticalPosition = position === 'left' || position === 'right',
                tabStrip = that.$.tabStrip;

            that._removeInlineStyle();

            switch (tabOverflow) {
                case 'scroll':
                case 'dropdown':
                    if (that._firefox && that.textOrientation === 'vertical' && verticalPosition) {
                        that._fixTabStripFirefox(tabStrip);
                    }

                    break;
                case 'wrap':
                    if (that.textOrientation === 'vertical') {
                        if (that._firefox) {
                            // fix for flexbox-related issues in Firefox
                            if (verticalPosition) {
                                that._fixTabStripFirefox(tabStrip);
                            } else {
                                var tabStripChildren = tabStrip.children;
                                var greatestHeight = tabStripChildren[0].offsetHeight;

                                for (var i = 1; i < tabStripChildren.length; i++) {
                                    greatestHeight = Math.max(greatestHeight, tabStripChildren[i].offsetHeight);
                                }

                                for (var _i4 = 1; _i4 < tabStripChildren.length; _i4++) {
                                    tabStripChildren[_i4].style.height = greatestHeight + 'px';
                                }

                                that._inlineStyleTabStripChildren = true;
                            }
                        } else if (!verticalPosition) {
                            if (tabStrip.scrollHeight > tabStrip.offsetHeight) {
                                tabStrip.style.height = tabStrip.scrollHeight + 'px';

                                if (position === 'bottom') {
                                    tabStrip.style.flexWrap = 'wrap-reverse';
                                }

                                that._inlineStyleTabStrip = true;
                            }
                        }
                    } else if (verticalPosition && tabStrip.scrollWidth > tabStrip.offsetWidth) {
                        tabStrip.style.width = tabStrip.scrollWidth + 'px';

                        if (position === 'right') {
                            tabStrip.style.flexWrap = 'wrap-reverse';
                        }

                        that._inlineStyleTabStrip = true;
                    }

                    break;
                case 'shrink':
                    {
                        if (!verticalPosition) {
                            if (tabStrip.scrollWidth > tabStrip.offsetWidth) {
                                tabStrip.$.addClass('shrink-tabs');
                            }
                        } else if (that._firefox && that.textOrientation === 'vertical') {
                            var _tabStripChildren = tabStrip.children,
                                computedStyle = window.getComputedStyle(_tabStripChildren[0]),
                                paddings = parseInt(computedStyle.paddingLeft, 10) + parseInt(computedStyle.paddingRight, 10);
                            var maxWidth = 0;

                            for (var _i5 = 0; _i5 < _tabStripChildren.length; _i5++) {
                                maxWidth = Math.max(maxWidth, _tabStripChildren[_i5].firstElementChild.offsetWidth);
                            }

                            tabStrip.style.width = paddings + maxWidth + 'px';
                            that._inlineStyleTabStrip = true;
                            break;
                        }
                    }
            }

            that._applyConditionalTabOverflow();
            that._getTabCoordinates();
            that._fixTabStripFlex();
        }

        /**
         * jqx-tab-item closeButtonVisibilityChange event handler.
         */

    }, {
        key: '_closeButtonVisibilityChangeHandler',
        value: function _closeButtonVisibilityChangeHandler(event) {
            var that = this,
                index = event.target.index;

            if (that.closeButtonMode === 'selected') {
                that._tabLabelContainers[index].closeButtonEnabled = event.detail.hidden;
                return;
            }

            if (event.detail.hidden) {
                that._disableCloseButton(index);
            } else {
                that._enableCloseButton(index);
            }
        }

        /**
         * Closes the pop-up in mode 'dropdown'.
         */

    }, {
        key: '_closeDropDownButtonPopup',
        value: function _closeDropDownButtonPopup() {
            var that = this;

            if (that._dropDownButtonPopupOpened) {
                that.$dropDownButtonPopup.addClass('jqx-hidden');
                that._dropDownButtonPopupOpened = false;
            }
        }

        /**
         * Closes the open group pop-up.
         */

    }, {
        key: '_closeGroupPopup',
        value: function _closeGroupPopup() {
            var that = this;

            if (!that._openPopup) {
                return;
            }

            that._openPopup.$.addClass('jqx-hidden');
            that._openPopup = undefined;
        }

        /**
         * Container event handler.
         */

    }, {
        key: '_containerHandler',
        value: function _containerHandler(event) {
            var that = this,
                eventType = event.type;

            if (that.disabled || that.readonly || that._resizing && eventType !== 'mouseout' || (eventType === 'down' || eventType === 'up') && event.which !== 1) {
                return;
            }

            if (eventType === 'up') {
                event.stopPropagation();
            }

            var target = event.originalEvent ? event.originalEvent.target : event.target;

            if (that.$.tabContentSection.contains(target)) {
                return;
            }

            if (that.$.dropDownButton.contains(target)) {
                that._dropDownButtonHandler(target, event);
                return;
            }

            that._tabStripHandler(target, event);
        }

        /**
         * Disables the close button of a tab.
         *
         * @param {Number} index The index of which tab's close button to hide.
         */

    }, {
        key: '_disableCloseButton',
        value: function _disableCloseButton(index) {
            var that = this,
                tabLabelContainer = that._tabLabelContainers[index];

            tabLabelContainer.closeButtonEnabled = false;

            if (that.closeButtons) {
                that._hideCloseButton(tabLabelContainer);
            }
        }

        /**
         * Document (mouse)move handler.
         */

    }, {
        key: '_documentMoveHandler',
        value: function _documentMoveHandler(event) {
            var that = this,
                orientationSettings = that._orientationSettings;

            if (that._dragging) {
                if (!that._reorderStartThrown) {
                    that._fireDragEvent(event, 'reorderStart');
                    that._reorderStartThrown = true;
                }

                var mouseCoordinate = event[orientationSettings.coordinate],
                    condition = that.tabOverflow !== 'wrap' ? function (currentCoordinateSet) {
                    return mouseCoordinate >= currentCoordinateSet[orientationSettings.from] && mouseCoordinate <= currentCoordinateSet[orientationSettings.to];
                } : function (currentCoordinateSet) {
                    return event.pageX >= currentCoordinateSet.fromX && event.pageX <= currentCoordinateSet.toX && event.pageY >= currentCoordinateSet.fromY && event.pageY <= currentCoordinateSet.toY;
                };
                var inTab = false;

                for (var i = 0; i < that._tabCoordinates.length; i++) {
                    var currentCoordinateSet = that._tabCoordinates[i];

                    if (condition(currentCoordinateSet)) {
                        inTab = i;
                        break;
                    }
                }

                if (that._preventReorder !== true && inTab !== false && inTab !== that._draggedIndex) {
                    that._reorderTabs(that._draggedIndex, inTab);

                    that._closeGroupPopup();

                    that._draggedIndex = inTab;
                    that._getReorderItems();
                    that._getTabCoordinates();
                }

                var draggedIndexCoordinates = that._tabCoordinates[that._draggedIndex];

                if (that.tabOverflow !== 'wrap' && (mouseCoordinate < draggedIndexCoordinates[orientationSettings.from] || mouseCoordinate > draggedIndexCoordinates[orientationSettings.to]) || that.tabOverflow === 'wrap' && (event.originalEvent.target.closest('.jqx-tab-label-container') !== null || event.originalEvent.target.closest('.jqx-tab-group-container') !== null) && !(event.pageX >= draggedIndexCoordinates.fromX && event.pageX <= draggedIndexCoordinates.toX && event.pageY >= draggedIndexCoordinates.fromY && event.pageY <= draggedIndexCoordinates.toY)) {
                    that._preventReorder = true;
                } else {
                    that._preventReorder = false;
                }
            } else if (that._resizing) {
                that.$.resizeToken.style[orientationSettings.edge] = event[orientationSettings.coordinate] - that.tabHeaderSectionCoordinate + 'px';
                that.$resizeToken.removeClass('jqx-hidden');
            }
        }

        /**
         * Document (mouse)up handler.
         */

    }, {
        key: '_documentUpHandler',
        value: function _documentUpHandler(event) {
            var that = this;
            var target = event.originalEvent.target;

            if (that._openPopup && target.closest('.jqx-tab-group-container') !== that._openPopup.groupContainer) {
                that._openPopup.$.addClass('jqx-hidden');
                that._openPopup = undefined;
            }

            if (!that.$.dropDownButton.contains(target)) {
                that._closeDropDownButtonPopup();
            }

            if (that._dragging) {
                if (that._draggedHoveredTab) {
                    if (!that._draggedHoveredTab.contains(target)) {
                        that._draggedHoveredTab.$.removeClass('jqx-tab-hovered');
                    }

                    delete that._draggedHoveredTab;
                }

                that._reorderedIndex = undefined;
                that._dragging = false;
                that._reorderStartThrown = false;
                that.removeAttribute('dragged');
                that._fireDragEvent(event, 'reorderEnd');
            }

            that._resize(event);

            if (that._tabToResize !== undefined) {
                that._tabToResize = undefined;
            }
        }

        /**
         * Dropdown button and pop-up event handler.
         */

    }, {
        key: '_dropDownButtonHandler',
        value: function _dropDownButtonHandler(target, event) {
            var that = this,
                eventType = event.type;

            if (that.$.dropDownButtonPopup.contains(target)) {
                if (target.classList.contains('jqx-tab-label-container')) {
                    switch (eventType) {
                        case 'down':
                            that._downTarget = target;
                            break;
                        case 'mouseout':
                            target.classList.remove('jqx-tab-hovered');
                            break;
                        case 'mouseover':
                            target.classList.add('jqx-tab-hovered');
                            break;
                        case 'up':
                            if (target === that._downTarget) {
                                that.select([].concat(babelHelpers.toConsumableArray(that.$.dropDownButtonPopup.children)).indexOf(target));
                                that._closeDropDownButtonPopup();
                            }
                            break;
                    }
                }
            } else {
                if (eventType === 'down') {
                    that._downTarget = that.$.dropDownButton;
                } else if (eventType === 'up' && that._downTarget === that.$.dropDownButton) {
                    if (!that._dropDownButtonPopupOpened) {
                        that.$dropDownButtonPopup.removeClass('jqx-hidden');
                        that._dropDownButtonPopupOpened = true;
                    } else {
                        that._closeDropDownButtonPopup();
                    }
                }
            }
        }

        /**
         * Enables the close button of a tab.
         *
         * @param {Number} index The index of which tab's close button to show.
         */

    }, {
        key: '_enableCloseButton',
        value: function _enableCloseButton(index) {
            var that = this,
                tabLabelContainer = that._tabLabelContainers[index];

            tabLabelContainer.closeButtonEnabled = true;

            if (that.closeButtons) {
                that._showCloseButton(tabLabelContainer);
            }
        }

        /**
         * Ensures all inner custom elements are ready before the Tabs is initialized.
         */

    }, {
        key: '_ensureItemsReady',
        value: function _ensureItemsReady(nodes, callback) {
            var that = this;

            var contextCallback = function contextCallback() {
                var setContext = function setContext(context) {
                    for (var i = 0; i < nodes.length; i++) {
                        nodes[i].context = context === 'node' ? nodes[i] : document;
                    }
                };

                setContext('node');
                callback();
                setContext();
            };

            if (nodes.length === 0) {
                contextCallback();
            } else {
                that._nodesReadyListeners = 0;

                for (var i = 0; i < nodes.length; i++) {
                    var node = nodes[i];

                    var readyEventHandler = function () {
                        that._nodesReadyListeners--;
                        if (that._nodesReadyListeners === 0) {
                            contextCallback();

                            delete that._nodesReadyListeners;
                        }
                    }.bind(that);

                    if (!node.isCompleted) {
                        that._nodesReadyListeners++;
                        node.onCompleted = readyEventHandler;
                    }
                }

                if (that._nodesReadyListeners === 0) {
                    contextCallback();
                }
            }
        }

        /**
         * Fires the "reorderStart" or "reorderEnd" event.
         */

    }, {
        key: '_fireDragEvent',
        value: function _fireDragEvent(event, eventToFire) {
            var that = this,
                target = that.$.tabStrip.children[that._draggedIndex],
                tab = target.tab;
            var selected = void 0,
                index = void 0,
                label = void 0;

            if (tab) {
                selected = tab.selected;
                index = tab.index;
                label = tab.label;
            } else {
                label = target.group;
            }

            that.$.fireEvent(eventToFire, {
                'position': { left: event.pageX, top: event.pageY }, 'target': target, 'selected': selected, 'index': index, 'label': label
            });
        }

        /**
         * Fix for the tab strip layout in Firefox when the position and text orientation are vertical.
         */

    }, {
        key: '_fixTabStripFirefox',
        value: function _fixTabStripFirefox(tabStrip) {
            var that = this,
                tabStripChildren = that.$.tabStrip.children;
            var rect = tabStripChildren[0].getBoundingClientRect(),
                leastStartX = rect.left,
                greatestEndX = leastStartX + tabStripChildren[0].offsetWidth;

            for (var i = 1; i < tabStripChildren.length; i++) {
                rect = tabStripChildren[i].getBoundingClientRect();
                leastStartX = Math.min(leastStartX, rect.left);
                greatestEndX = Math.max(greatestEndX, rect.left + tabStripChildren[i].offsetWidth);
            }

            tabStrip.style.width = greatestEndX - leastStartX + 'px';
            that._inlineStyleTabStrip = true;
        }

        /**
         * Fix for a flexbox-related issue in Chrome.
         */

    }, {
        key: '_fixTabStripFlex',
        value: function _fixTabStripFlex() {
            var that = this;

            if (that.textOrientation === 'vertical' && (that.position === 'left' || that.position === 'right') && !that._firefox) {
                setTimeout(function () {
                    that.$tabHeaderSection.addClass('jqx-hidden');
                    setTimeout(function () {
                        that.$tabHeaderSection.removeClass('jqx-hidden');
                        that._getTabCoordinates();
                    }, 0);
                }, 0);
            }
        }

        /**
         * Returns the custom element corresponding to the passed tab strip element.
         */

    }, {
        key: '_getCorrespondingCustomElement',
        value: function _getCorrespondingCustomElement(currentItem) {
            if (currentItem.$.hasClass('jqx-tab-label-container')) {
                return currentItem.tab;
            } else {
                return this.$.tabContentSection.querySelector('jqx-tab-items-group[label="' + currentItem.group + '"]');
            }
        }

        /**
         * Stores the items that can be reordered in an Array.
         */

    }, {
        key: '_getReorderItems',
        value: function _getReorderItems() {
            var that = this;
            var reorderItems = void 0;

            if (that._groups.length === 0) {
                reorderItems = that._tabLabelContainers;
            } else {
                reorderItems = [].concat(babelHelpers.toConsumableArray(that.$.tabStrip.children));

                if (that.addNewTab) {
                    reorderItems.pop();
                }
            }

            that._reorderItems = reorderItems;
        }

        /**
         * Stores the coordinates of tab label containers in an Array (for use in reorder and resize functionalities).
         */

    }, {
        key: '_getTabCoordinates',
        value: function _getTabCoordinates() {
            var that = this;

            if (!that.reorder && !that.resize || that.position === 'hidden') {
                return;
            }

            var coordinates = [],
                windowScrollX = window.scrollX || window.pageXOffset,
                windowScrollY = window.scrollY || window.pageYOffset;

            for (var i = 0; i < that._reorderItems.length; i++) {
                var currentTabLabelContainer = that._reorderItems[i],
                    boundingClientRect = currentTabLabelContainer.getBoundingClientRect();

                coordinates.push({
                    fromX: boundingClientRect.left + windowScrollX,
                    toX: boundingClientRect.right + windowScrollX,
                    fromY: boundingClientRect.top + windowScrollY,
                    toY: boundingClientRect.bottom + windowScrollY
                });
            }

            that._tabCoordinates = coordinates;
        }

        /**
         * Stores tabs in an Array.
         */

    }, {
        key: '_getTabs',
        value: function _getTabs() {
            var that = this,
                tabs = that.getElementsByTagName('jqx-tab-item');

            if (that.selectedIndex !== null) {
                if (tabs.length === 0) {
                    that.selectedIndex = null;
                } else {
                    that.selectedIndex = Math.max(0, Math.min(that.selectedIndex, tabs.length - 1));
                }
            }

            that._tabs = [].concat(babelHelpers.toConsumableArray(tabs));
        }

        /**
         * Group container event handler.
         */

    }, {
        key: '_groupContainerHandler',
        value: function _groupContainerHandler(currentElement, eventType) {
            var that = this,
                popup = currentElement.popup;

            if (eventType === 'down') {
                that._downTarget = currentElement;

                if (that.reorder && that._reorderItems.length > 1) {
                    that._getTabCoordinates();
                    that._dragging = true;
                    that.setAttribute('dragged', '');
                    that._draggedIndex = [].concat(babelHelpers.toConsumableArray(that.$.tabStrip.children)).indexOf(currentElement);
                }

                return;
            }

            if (!that._dragging) {
                if (popup !== that._openPopup && eventType === 'mouseover' && !currentElement.classList.contains('jqx-tab-group-selected')) {
                    currentElement.$.addClass('jqx-tab-hovered');
                } else if (eventType === 'mouseout') {
                    currentElement.$.removeClass('jqx-tab-hovered');
                }
            }

            if (eventType !== 'up' || that._downTarget !== currentElement || that._reorderedIndex !== undefined) {
                return;
            }

            if (popup === that._openPopup) {
                that._closeGroupPopup();

                if (!currentElement.classList.contains('jqx-tab-group-selected')) {
                    currentElement.$.addClass('jqx-tab-hovered');
                }
            } else {
                if (that._openPopup) {
                    that._openPopup.$.addClass('jqx-hidden');
                }

                popup.$.removeClass('jqx-hidden');
                that._positionGroupPopup(popup, currentElement);
                that._openPopup = popup;

                currentElement.$.removeClass('jqx-tab-hovered');
            }
        }

        /**
         * Handles changes to the "position" property.
         */

    }, {
        key: '_handlePosition',
        value: function _handlePosition(newPosition, oldPosition) {
            var that = this;

            if ([undefined, 'top', 'left', 'hidden'].indexOf(oldPosition) !== -1 && (newPosition === 'bottom' || newPosition === 'right')) {
                that.$.container.insertBefore(that.$.tabContentSection, that.$.tabHeaderSection);
            } else if ((oldPosition === 'bottom' || oldPosition === 'right') && ['top', 'left', 'hidden'].indexOf(newPosition) !== -1) {
                that.$.container.insertBefore(that.$.tabHeaderSection, that.$.tabContentSection);
            }

            if (newPosition === 'top' || newPosition === 'bottom') {
                that._orientationSettings = { coordinate: 'pageX', dimension: 'width', edge: 'left', from: 'fromX', size: 'offsetWidth', to: 'toX' };
                that.removeAttribute('vertical');
                that.setAttribute('horizontal', '');

                that.$arrowNear.removeClass('jqx-arrow-up');
                that.$arrowNear.addClass('jqx-arrow-left');
                that.$arrowFar.removeClass('jqx-arrow-down');
                that.$arrowFar.addClass('jqx-arrow-right');
            } else {
                that._orientationSettings = { coordinate: 'pageY', dimension: 'height', edge: 'top', from: 'fromY', size: 'offsetHeight', to: 'toY' };
                that.removeAttribute('horizontal');
                that.setAttribute('vertical', '');

                that.$arrowNear.removeClass('jqx-arrow-left');
                that.$arrowNear.addClass('jqx-arrow-up');
                that.$arrowFar.removeClass('jqx-arrow-right');
                that.$arrowFar.addClass('jqx-arrow-down');
            }

            that.$.dropDownButtonArrow.innerHTML = that._arrowCodes[that.position];
        }

        /**
         * Handles changes to the "scrollButtonsPosition" property.
         */

    }, {
        key: '_handleScrollButtonsPosition',
        value: function _handleScrollButtonsPosition(newScrollButtonsPosition, oldScrollButtonsPosition) {
            var that = this,
                tabHeaderSection = that.$.tabHeaderSection;

            if (newScrollButtonsPosition === oldScrollButtonsPosition) {
                return;
            }

            if (newScrollButtonsPosition === 'both') {
                if (oldScrollButtonsPosition === 'near') {
                    tabHeaderSection.insertBefore(that.$.scrollButtonFar, that.$.dropDownButton);
                } else {
                    tabHeaderSection.insertBefore(that.$.scrollButtonNear, that.$.tabStrip);
                }
            } else if (newScrollButtonsPosition === 'near') {
                if (oldScrollButtonsPosition === 'far') {
                    tabHeaderSection.insertBefore(that.$.scrollButtonNear, that.$.tabStrip);
                }

                tabHeaderSection.insertBefore(that.$.scrollButtonFar, that.$.tabStrip);
            } else {
                if (oldScrollButtonsPosition === 'near') {
                    tabHeaderSection.insertBefore(that.$.scrollButtonFar, that.$.dropDownButton);
                }

                tabHeaderSection.insertBefore(that.$.scrollButtonNear, that.$.scrollButtonFar);
            }
        }

        /**
         * Hides the close button of a tab.
         */

    }, {
        key: '_hideCloseButton',
        value: function _hideCloseButton(tabLabelContainer) {
            tabLabelContainer.children[0].$.removeClass('jqx-close-button-enabled');
            tabLabelContainer.children[1].$.addClass('jqx-hidden');
        }

        /**
         * jqx-tab-item indexChange event handler.
         */

    }, {
        key: '_indexChangeHandler',
        value: function _indexChangeHandler(event) {
            var that = this,
                oldIndex = event.detail.oldIndex,
                validNewIndex = Math.max(0, Math.min(event.detail.newIndex, that._tabs.length - 1));

            if (oldIndex !== validNewIndex) {
                if (that._groups.length === 0) {
                    that._reorderTabs(oldIndex, validNewIndex);
                } else {
                    var tabItem = event.detail.tabItem;

                    tabItem._setIndex(oldIndex);
                    that.remove(oldIndex);
                    that.insert(validNewIndex, { node: tabItem });

                    if (that.selectedIndex === oldIndex) {
                        that._select(validNewIndex, false);
                    }
                }

                that._reorderedIndex = undefined;
            }
        }

        /**
         * Inserts the "add new" tab.
         */

    }, {
        key: '_insertAddNewTab',
        value: function _insertAddNewTab() {
            var that = this,
                tabLabelContainer = that._addTabLabelContainer(undefined, true).tabLabelContainer;

            tabLabelContainer.$.addClass('jqx-add-new-tab');

            that.$.tabStrip.appendChild(tabLabelContainer);

            that._addNewTab = tabLabelContainer;
        }

        /**
         * Inserts a tab into an existing group.
         */

    }, {
        key: '_insertIntoExistingGroup',
        value: function _insertIntoExistingGroup(details) {
            var that = this,
                jqxTabItemsGroup = details.jqxTabItemsGroup,
                tab = details.tab,
                tabLabelContainer = details.tabLabelContainer,
                group = details.group,
                groupLabel = that._groupLabels[that._groups.indexOf(group)],
                groupPopup = groupLabel.popup;
            var index = details.index;

            index = Math.max(0, Math.min(index, jqxTabItemsGroup.childElementCount));

            groupPopup.insertBefore(tabLabelContainer, groupPopup.children[index]);

            var sibling = jqxTabItemsGroup.children[index];
            var overallIndex = void 0;

            if (sibling) {
                overallIndex = sibling.index;
            } else {
                overallIndex = jqxTabItemsGroup.children[index - 1].index + 1;
            }

            jqxTabItemsGroup.insertBefore(tab, sibling);

            that._tabLabelContainers.splice(overallIndex, 0, tabLabelContainer);
            that.$.dropDownButtonPopup.insertBefore(details.dropDownPopupLabelContainer, that.$.dropDownButtonPopup.children[overallIndex] || null);
            that._tabs.splice(overallIndex, 0, tab);

            index = overallIndex;

            tab.group = group;

            that._updateIndexes(index);
        }

        /**
         * Inserts a tab into a new group.
         */

    }, {
        key: '_insertIntoNewGroup',
        value: function _insertIntoNewGroup(details) {
            var that = this,
                tab = details.tab,
                tabLabelContainer = details.tabLabelContainer,
                group = details.group,
                groupContainers = that._addGroupContainer(group),
                groupLabel = groupContainers.label,
                groupPopup = groupContainers.popup;

            groupPopup.appendChild(tabLabelContainer);

            that._groups.push(group);

            var index = Math.max(0, Math.min(details.index, that.$.tabStrip.childElementCount)),
                tabStripIndex = index;

            if (that._addNewTab && tabStripIndex === that.$.tabStrip.childElementCount) {
                tabStripIndex--;
            }

            that.$.tabStrip.insertBefore(groupLabel, that.$.tabStrip.children[tabStripIndex] || null);

            that._groupLabels.push(groupLabel);

            var newJqxTabItemsGroup = document.createElement('jqx-tab-items-group');

            newJqxTabItemsGroup.appendChild(tab);
            that.$.tabContentSection.insertBefore(newJqxTabItemsGroup, that.$.tabContentSection.children[index]);
            newJqxTabItemsGroup.label = group;

            var previousSibling = newJqxTabItemsGroup.previousElementSibling;
            var overallIndex = 0;

            if (previousSibling) {
                if (previousSibling instanceof JQX.TabItem) {
                    overallIndex = previousSibling.index + 1;
                } else {
                    overallIndex = previousSibling.lastElementChild.index + 1;
                }
            }

            that._tabLabelContainers.splice(overallIndex, 0, tabLabelContainer);
            that.$.dropDownButtonPopup.insertBefore(details.dropDownPopupLabelContainer, that.$.dropDownButtonPopup.children[overallIndex] || null);
            that._tabs.splice(overallIndex, 0, tab);

            index = overallIndex;

            tab.group = group;

            that._updateIndexes(index);
        }

        /**
         * Inserts a stand-alone tab when there are groups.
         */

    }, {
        key: '_insertNearAGroup',
        value: function _insertNearAGroup(details) {
            var that = this,
                tab = details.tab,
                tabLabelContainer = details.tabLabelContainer;
            var index = details.index;

            index = Math.max(0, Math.min(index, that._tabs.length));

            var previous = that._tabs[index - 1],
                next = that._tabs[index],
                groupOfNext = next ? next.group : undefined;

            if (previous && previous.group !== null && next && groupOfNext !== null) {
                // insert into group
                next.tabLabelContainer.parentElement.insertBefore(tabLabelContainer, next.tabLabelContainer);
                next.parentElement.insertBefore(tab, next);

                tab.group = groupOfNext;
            } else {
                if (next) {
                    if (groupOfNext !== null) {
                        that.$.tabStrip.insertBefore(tabLabelContainer, that._groupLabels[that._groups.indexOf(groupOfNext)]);
                        that.$.tabContentSection.insertBefore(tab, that.$.tabContentSection.querySelector('jqx-tab-items-group[label="' + groupOfNext + '"]'));
                    } else {
                        that.$.tabStrip.insertBefore(tabLabelContainer, next.tabLabelContainer);
                        that.$.tabContentSection.insertBefore(tab, next);
                    }
                } else {
                    that.$.tabStrip.insertBefore(tabLabelContainer, that._addNewTab || null);
                    that.$.tabContentSection.appendChild(tab);
                }
            }

            that._tabLabelContainers.splice(index, 0, tabLabelContainer);
            that.$.dropDownButtonPopup.insertBefore(details.dropDownPopupLabelContainer, that.$.dropDownButtonPopup.children[index] || null);
            that._tabs.splice(index, 0, tab);

            that._updateIndexes(index);
        }

        /**
         * Inserts a tab when there are no groups.
         */

    }, {
        key: '_insertNoGrouping',
        value: function _insertNoGrouping(tabDetails) {
            var that = this,
                index = Math.max(0, Math.min(tabDetails.index, that._tabs.length)),
                tab = tabDetails.tab,
                tabLabelContainer = tabDetails.tabLabelContainer;

            that.$.tabStrip.insertBefore(tabLabelContainer, that._tabLabelContainers[index] || that._addNewTab || null);
            that.$.tabContentSection.insertBefore(tab, that._tabs[index] || null);

            that._tabLabelContainers.splice(index, 0, tabLabelContainer);
            that.$.dropDownButtonPopup.insertBefore(tabDetails.dropDownPopupLabelContainer, that.$.dropDownButtonPopup.children[index] || null);
            that._tabs.splice(index, 0, tab);

            that._updateIndexes(index);
        }

        /**
         * keydown event handler.
         */

    }, {
        key: '_keydownHandler',
        value: function _keydownHandler(event) {
            var that = this,
                key = event.key;

            if (document.activeElement !== that || ['ArrowLeft', 'ArrowDown', 'ArrowRight', 'ArrowUp', 'End', 'Home'].indexOf(key) === -1 || that.disabled || that.readonly || that.selectionMode === 'none' || that.selectedIndex === null) {
                return;
            }

            event.preventDefault();

            var lastTabIndex = that._tabs.length - 1;
            var indexToSelect = void 0;

            switch (key) {
                case 'ArrowLeft':
                case 'ArrowUp':
                    // selects previous tab
                    if (that.selectedIndex === 0) {
                        return;
                    }

                    indexToSelect = that.selectedIndex - 1;
                    break;
                case 'ArrowRight':
                case 'ArrowDown':
                    // selects next tab
                    if (that.selectedIndex === lastTabIndex) {
                        return;
                    }

                    indexToSelect = that.selectedIndex + 1;
                    break;
                case 'End':
                    if (that.selectedIndex === lastTabIndex) {
                        return;
                    }

                    indexToSelect = lastTabIndex;
                    break;
                case 'Home':
                    if (that.selectedIndex === 0) {
                        return;
                    }

                    indexToSelect = 0;
                    break;
            }

            that.select(indexToSelect);
        }

        /**
         * Tab label container/label text container event handler.
         */

    }, {
        key: '_labelContainerHandler',
        value: function _labelContainerHandler(currentElement, eventType) {
            var that = this,
                click = eventType === 'up' && that._downTarget === currentElement;

            if (eventType === 'down') {
                that._downTarget = currentElement;
            }

            if (currentElement === that._addNewTab) {
                that._addNewTabHandler(currentElement, eventType, click);
                return;
            }

            var index = currentElement.tab.index,
                currentElementStatic = !(that._dragging && that._reorderedIndex !== undefined);

            if (click && index === that.selectedIndex) {
                that._closeGroupPopup();

                if (currentElementStatic && currentElement.tab.group === null) {
                    that._toggleCollapsedState();
                }
            }

            if (currentElementStatic && that.selectionMode === 'click' && click || !that._dragging && (that.selectionMode === eventType || that.selectionMode === 'mouseenter' && eventType === 'mouseover')) {
                that._select(index, true);
            }

            if (!that._dragging && (that.selectionMode === 'click' || that.selectionMode === 'dblclick')) {
                if (eventType === 'mouseover' && !currentElement.$.hasClass('jqx-tab-selected')) {
                    currentElement.$.addClass('jqx-tab-hovered');
                } else if (eventType === 'mouseout') {
                    currentElement.$.removeClass('jqx-tab-hovered');
                }
            }

            if (that.reorder && eventType === 'down' && currentElement.tab.group === null && that._reorderItems.length > 1) {
                that._getTabCoordinates();
                that._dragging = true;
                that.setAttribute('dragged', '');

                if (currentElement.$.hasClass('jqx-tab-hovered')) {
                    that._draggedHoveredTab = currentElement;
                }

                if (that._groups.length === 0) {
                    that._draggedIndex = currentElement.tab.index;
                } else {
                    that._draggedIndex = [].concat(babelHelpers.toConsumableArray(that.$.tabStrip.children)).indexOf(currentElement);
                }
            }
        }

        /**
         * jqx-tab-item labelSizeChange event handler.
         */

    }, {
        key: '_labelSizeChangeHandler',
        value: function _labelSizeChangeHandler(event) {
            var that = this,
                newSize = event.detail.size;
            var correspondingLabelContainer = void 0;

            if (that.tabOverflow === 'shrink') {
                return;
            }

            if (event.target instanceof JQX.TabItem) {
                correspondingLabelContainer = event.target.tabLabelContainer;
            } else {
                correspondingLabelContainer = that._groupLabels[that._groups.indexOf(event.target.label)];
            }

            if (newSize !== null) {
                correspondingLabelContainer.style[that._orientationSettings.dimension] = parseInt(newSize, 10) + 'px';
            } else {
                correspondingLabelContainer.style.removeProperty(that._orientationSettings.dimension);
            }

            that._applyTabOverflow();
        }

        /**
         * Orders tabs initially.
         */

    }, {
        key: '_orderTabs',
        value: function _orderTabs() {
            var that = this,
                groups = that.getElementsByTagName('jqx-tab-items-group'),
                indexes = [],
                list = [];
            var unset = true,
                ambiguous = false;

            if (groups.length === 0) {
                for (var i = 0; i < that._tabs.length; i++) {
                    var tab = that._tabs[i],
                        index = tab.index;

                    if (unset && index !== null) {
                        unset = false;
                    }

                    if (indexes.indexOf(index || 0) !== -1) {
                        ambiguous = true;

                        if (index !== null) {
                            break;
                        }
                    }

                    indexes.push(index || 0);
                    list.push({ tab: tab, index: index });
                }
            }

            if (!ambiguous) {
                var sortedIndexes = indexes.slice(0).sort(function (a, b) {
                    return a - b;
                });

                if (JSON.stringify(indexes) === JSON.stringify(sortedIndexes)) {
                    unset = true;
                }
            }

            if (!unset && !ambiguous) {
                list.sort(function (a, b) {
                    return a.index - b.index;
                });

                for (var _i6 = 0; _i6 < list.length; _i6++) {
                    var _tab = list[_i6].tab;

                    _tab._setIndex(_i6);
                    that.$.tabContentSection.removeChild(_tab);
                }

                for (var _i7 = 0; _i7 < list.length; _i7++) {
                    var _tab2 = list[_i7].tab;

                    that.$.tabContentSection.appendChild(_tab2);
                    that._tabs[_i7] = _tab2;
                }
            } else {
                if (!unset) {
                    // eslint-disable-next-line
                    console.warn(that.localize('ambiguousIndexes'));
                }

                for (var _i8 = 0; _i8 < that._tabs.length; _i8++) {
                    that._tabs[_i8]._setIndex(_i8);
                }
            }
        }

        /**
         * Populates the tab strip.
         */

    }, {
        key: '_populateTabStrip',
        value: function _populateTabStrip() {
            var that = this,
                documentFragment = document.createDocumentFragment(),
                tabLabelContainers = [],
                groups = [],
                groupLabels = [];

            for (var i = 0; i < that._tabs.length; i++) {
                var tab = that._tabs[i],
                    tabParentElement = tab.parentElement,
                    group = tabParentElement instanceof JQX.TabItemsGroup ? tabParentElement.label : null;

                tab.group = group;

                var labelContainers = that._addTabLabelContainer(tab),
                    tabLabelContainer = labelContainers.tabLabelContainer,
                    dropDownPopupLabelContainer = labelContainers.dropDownPopupLabelContainer;

                if (that.selectedIndex === i) {
                    tabLabelContainer.$.addClass('jqx-tab-selected');
                }

                tab.tabLabelContainer = tabLabelContainer;
                tabLabelContainer.tab = tab;

                tabLabelContainers.push(tabLabelContainer);

                if (group === null) {
                    documentFragment.appendChild(tabLabelContainer);
                } else {
                    that._addGroupElements({ documentFragment: documentFragment, groups: groups, groupLabels: groupLabels, i: i, group: group, tabLabelContainer: tabLabelContainer, jqxTabItemsGroup: tabParentElement });
                }

                that.$.dropDownButtonPopup.appendChild(dropDownPopupLabelContainer);
            }

            that.$.tabStrip.appendChild(documentFragment);

            that._tabLabelContainers = tabLabelContainers;
            that._groups = groups;
            that._groupLabels = groupLabels;
        }

        /**
         * Positions a group pop-up.
         */

    }, {
        key: '_positionGroupPopup',
        value: function _positionGroupPopup(popup, groupLabel) {
            var that = this,
                position = that.position;

            if (position === 'top' || position === 'bottom') {
                popup.style.left = groupLabel.offsetLeft - that.$.tabStrip.scrollLeft + 'px';

                if (position === 'top') {
                    popup.style.top = groupLabel.offsetTop + groupLabel.offsetHeight + 'px';
                } else {
                    popup.style.top = groupLabel.offsetTop + 'px';
                }
            } else {
                popup.style.top = groupLabel.offsetTop - that.$.tabStrip.scrollTop + 'px';

                if (position === 'left') {
                    popup.style.left = groupLabel.offsetLeft + groupLabel.offsetWidth + 'px';
                } else {
                    popup.style.left = groupLabel.offsetLeft + 'px';
                }
            }
        }

        /**
         * Removes set inline style.
         */

    }, {
        key: '_removeInlineStyle',
        value: function _removeInlineStyle() {
            var that = this,
                tabStrip = that.$.tabStrip;

            if (that._inlineStyleTabStripChildren) {
                var tabStripChildren = tabStrip.children;

                for (var i = 0; i < tabStripChildren.length; i++) {
                    tabStripChildren[i].removeAttribute('style');
                    tabStripChildren[i].firstElementChild.classList.remove('jqx-tab-label-text-container-full-height');
                }
                delete that._inlineStyleTabStripChildren;
            }

            if (that._inlineStyleTabStrip) {
                tabStrip.removeAttribute('style');
                delete that._inlineStyleTabStrip;
            }

            tabStrip.$.removeClass('shrink-tabs');
        }

        /**
         * Positions a tab before or after another tab.
         */

    }, {
        key: '_reorderTabs',
        value: function _reorderTabs(firstTabIndex, secondTabIndex) {
            function reorderList(list, x, y) {
                var temp = list[x];

                list.splice(x, 1);
                list.splice(y, 0, temp);
            }

            var that = this;

            if (that._groups.length === 0) {
                var tabs = that._tabs,
                    tabLabelContainers = that._tabLabelContainers,
                    referenceNodeIndex = firstTabIndex > secondTabIndex ? secondTabIndex : secondTabIndex + 1;

                if (that.selectedIndex === firstTabIndex) {
                    that.selectedIndex = secondTabIndex;
                } else if (that.selectedIndex <= secondTabIndex && that.selectedIndex > firstTabIndex) {
                    that.selectedIndex--;
                } else if (that.selectedIndex >= secondTabIndex && that.selectedIndex < firstTabIndex) {
                    that.selectedIndex++;
                }

                that.$.tabStrip.insertBefore(tabLabelContainers[firstTabIndex], tabLabelContainers[referenceNodeIndex] || null);
                that.$.dropDownButtonPopup.insertBefore(that.$.dropDownButtonPopup.children[firstTabIndex], that.$.dropDownButtonPopup.children[referenceNodeIndex] || null);
                that.$.tabContentSection.insertBefore(tabs[firstTabIndex], tabs[referenceNodeIndex] || null);

                reorderList(tabs, firstTabIndex, secondTabIndex);
                reorderList(tabLabelContainers, firstTabIndex, secondTabIndex);

                that._updateTabIndexes();
            } else {
                that._reorderTabsGrouping(firstTabIndex, secondTabIndex);
            }

            that.$.fireEvent('reorder', { 'newIndex': secondTabIndex, 'originalIndex': firstTabIndex });

            that._reorderedIndex = secondTabIndex;
        }

        /**
         * Positions a tab before or after another tab when there are groups.
         */

    }, {
        key: '_reorderTabsGrouping',
        value: function _reorderTabsGrouping(firstTabIndex, secondTabIndex) {
            var that = this,
                tabStripChildren = that.$.tabStrip.children,
                tabContentSectionChildren = that.$.tabContentSection.children,
                referenceNodeIndex = firstTabIndex > secondTabIndex ? secondTabIndex : secondTabIndex + 1,
                selectedTab = that._tabs[that.selectedIndex];

            that.$.tabStrip.insertBefore(tabStripChildren[firstTabIndex], tabStripChildren[referenceNodeIndex] || null);
            that.$.tabContentSection.insertBefore(tabContentSectionChildren[firstTabIndex], tabContentSectionChildren[referenceNodeIndex] || null);

            that._groupLabels = [].concat(babelHelpers.toConsumableArray(that.$.tabStrip.getElementsByClassName('jqx-tab-group-container')));
            that._groups = [];

            for (var i = 0; i < that._groupLabels.length; i++) {
                that._groups.push(that._groupLabels[i].group);
            }

            that._tabs = [].concat(babelHelpers.toConsumableArray(that.$.tabContentSection.getElementsByTagName('jqx-tab-item')));

            var popupContentFragment = document.createDocumentFragment();
            var tabLabelContainers = [];

            for (var _i9 = 0; _i9 < that._tabs.length; _i9++) {
                popupContentFragment.appendChild(that.$.dropDownButtonPopup.children[that._tabs[_i9].index].cloneNode(true));
            }

            that.$.dropDownButtonPopup.innerHTML = '';
            that.$.dropDownButtonPopup.appendChild(popupContentFragment);

            for (var _i10 = 0; _i10 < that.$.tabStrip.childElementCount; _i10++) {
                var currentChild = that.$.tabStrip.children[_i10];

                if (currentChild.$.hasClass('jqx-tab-label-container') && currentChild !== that._addNewTab) {
                    tabLabelContainers.push(currentChild);
                } else if (currentChild.$.hasClass('jqx-tab-group-container')) {
                    tabLabelContainers = tabLabelContainers.concat([].concat(babelHelpers.toConsumableArray(currentChild.popup.children)));
                }
            }

            that._tabLabelContainers = tabLabelContainers;

            that._updateTabIndexes();

            if (selectedTab) {
                that.selectedIndex = selectedTab.index;
            }
        }

        /**
         * Resizes a tab strip element.
         */

    }, {
        key: '_resize',
        value: function _resize(event) {
            var that = this;

            if (!that._resizing) {
                return;
            }

            var orientationSettings = that._orientationSettings,
                sizeChange = event[orientationSettings.coordinate] - that._resizeFrom,
                customElement = that._getCorrespondingCustomElement(that._tabToResize);
            var oldSize = void 0;

            if (customElement.labelSize === null) {
                oldSize = that._tabToResize[orientationSettings.size];
            } else {
                oldSize = customElement.labelSize;
            }

            var newSize = Math.max(10, oldSize + sizeChange);

            if (newSize !== oldSize) {
                customElement._preventPropertyChangedHandler = true;
                customElement.labelSize = newSize;
                that._tabToResize.style[orientationSettings.dimension] = parseInt(newSize, 10) + 'px';
            }

            that.$resizeToken.addClass('jqx-hidden');
            that._applyTabOverflow();
            that._resizing = false;
            that.removeAttribute('resizing');
        }

        /**
         * Far scroll button click handler.
         */

    }, {
        key: '_scrollButtonFarClickHandler',
        value: function _scrollButtonFarClickHandler() {
            var that = this,
                tabStrip = that.$.tabStrip;

            if (that.position === 'top' || that.position === 'bottom') {
                tabStrip.scrollLeft = tabStrip.scrollLeft + 10;
            } else {
                tabStrip.scrollTop = tabStrip.scrollTop + 10;
            }
        }

        /**
         * Near scroll button click handler.
         */

    }, {
        key: '_scrollButtonNearClickHandler',
        value: function _scrollButtonNearClickHandler() {
            var that = this,
                tabStrip = that.$.tabStrip;

            if (that.position === 'top' || that.position === 'bottom') {
                tabStrip.scrollLeft = tabStrip.scrollLeft - 10;
            } else {
                tabStrip.scrollTop = tabStrip.scrollTop - 10;
            }
        }

        /**
         * Selects a tab.
         */

    }, {
        key: '_select',
        value: function _select(index, fireEvent, oldIndex) {
            var that = this;

            if (oldIndex === undefined) {
                oldIndex = that.selectedIndex;
            }

            if (index === oldIndex) {
                return;
            }

            if (oldIndex !== null) {
                that._tabs[oldIndex].selected = false;
                that._tabLabelContainers[oldIndex].$.removeClass('jqx-tab-selected');

                if (that.closeButtons && that.closeButtonMode === 'selected') {
                    that._disableCloseButton(oldIndex);
                }
            }

            var tab = that._tabs[index];

            that._tabs[index].selected = true;

            if (that.selectedIndex !== index) {
                that.selectedIndex = index;
            }

            that._tabLabelContainers[index].$.removeClass('jqx-tab-hovered');
            that._tabLabelContainers[index].$.addClass('jqx-tab-selected');

            if (that.closeButtons && that.closeButtonMode === 'selected') {
                that._enableCloseButton(index);
            }

            if (fireEvent) {
                that.$.fireEvent('change', { 'index': index, 'oldIndex': oldIndex });
            }

            that._closeGroupPopup();

            if (tab.group !== null) {
                if (!that._selectedGroup || that._selectedGroup.group !== tab.group) {
                    if (that._selectedGroup) {
                        that._selectedGroup.$.removeClass('jqx-tab-group-selected');
                    }

                    that._selectedGroup = that._groupLabels[that._groups.indexOf(tab.group)];
                    that._selectedGroup.$.addClass('jqx-tab-group-selected');
                }
            } else if (that._selectedGroup) {
                that._selectedGroup.$.removeClass('jqx-tab-group-selected');
                delete that._selectedGroup;
            }
        }

        /**
         * Document select start handler.
         */

    }, {
        key: '_selectStartHandler',
        value: function _selectStartHandler(event) {
            var that = this;

            if (that._dragging || that._resizing) {
                event.preventDefault();
            }
        }

        /**
         * Sets the label of a tab.
         */

    }, {
        key: '_setLabel',
        value: function _setLabel(label, labelTextContainer, dropDownPopupLabelContainer) {
            var potentialHTMLTemplate = document.getElementById(label);

            if (potentialHTMLTemplate !== null && potentialHTMLTemplate.tagName.toLowerCase() === 'template') {
                // label is the id of an HTML template
                var templateContent = document.importNode(potentialHTMLTemplate.content, true);

                labelTextContainer.appendChild(templateContent);

                if (dropDownPopupLabelContainer) {
                    var _templateContent = document.importNode(potentialHTMLTemplate.content, true);

                    dropDownPopupLabelContainer.appendChild(_templateContent);
                }
            } else {
                // label is string
                if (label === '') {
                    label = '&nbsp;';
                }

                labelTextContainer.innerHTML = label;

                if (dropDownPopupLabelContainer) {
                    dropDownPopupLabelContainer.innerHTML = label;
                }
            }
        }

        /**
         * Shows the close button of a tab.
         */

    }, {
        key: '_showCloseButton',
        value: function _showCloseButton(tabLabelContainer) {
            if (tabLabelContainer.closeButtonEnabled) {
                tabLabelContainer.children[0].$.addClass('jqx-close-button-enabled');
                tabLabelContainer.children[1].$.removeClass('jqx-hidden');
            }
        }

        /**
         * Tab strip event handler.
         */

    }, {
        key: '_tabStripHandler',
        value: function _tabStripHandler(target, event) {
            var that = this,
                eventType = event.type;

            if (eventType === 'down' && that._tabToResize !== undefined) {
                that._resizing = true;
                that.tabHeaderSectionCoordinate = that.$.tabHeaderSection.getBoundingClientRect()[that._orientationSettings.edge];
                return;
            }

            if (eventType === 'up' && (that.$.scrollButtonNear.contains(target) || that.$.scrollButtonFar.contains(target))) {
                that.focus();

                if (that.resize) {
                    that._getTabCoordinates();
                }
                return;
            }

            if (target.classList.contains('jqx-tab-close-button')) {
                // close button
                if (eventType === 'up') {
                    if (target === that._downTarget) {
                        var indexToClose = target.parentElement.tab.index,
                            closingEvent = that.$.fireEvent('closing', { 'index': indexToClose });

                        if (!closingEvent.defaultPrevented) {
                            that.remove(indexToClose);

                            that.$.fireEvent('close', { 'index': indexToClose });
                        }
                        return;
                    }
                } else if (eventType === 'down') {
                    that._downTarget = target;
                    return;
                } else if (!that._dragging) {
                    if (eventType === 'mouseover') {
                        target.$.addClass('jqx-tab-close-button-hovered');
                    } else if (eventType === 'mouseout') {
                        target.$.removeClass('jqx-tab-close-button-hovered');
                    }
                }
            }

            var closestLabelContainer = target.closest('.jqx-tab-label-container');

            if (closestLabelContainer !== null) {
                that._labelContainerHandler(closestLabelContainer, eventType);
                return;
            }

            var closestGroupContainer = target.closest('.jqx-tab-group-container');

            if (closestGroupContainer !== null) {
                that._groupContainerHandler(closestGroupContainer, eventType);
            }
        }

        /**
         * Tab strip mouseleave handler.
         */

    }, {
        key: '_tabStripMouseleaveHandler',
        value: function _tabStripMouseleaveHandler() {
            var that = this;

            if (that.resize && !that._resizing && that.hasAttribute('resizing')) {
                that.removeAttribute('resizing');
            }
        }

        /**
         * Tab strip (mouse)move handler.
         */

    }, {
        key: '_tabStripMoveHandler',
        value: function _tabStripMoveHandler(event) {
            var that = this;

            if (!that.resize || that._resizing || that._dragging || that.tabOverflow === 'shrink') {
                return;
            }

            var orientationSettings = that._orientationSettings,
                currentCoordinate = event[orientationSettings.coordinate],
                tabCoordinates = that._tabCoordinates;
            var tabToResize = void 0;

            for (var i = 0; i < tabCoordinates.length; i++) {
                var currentTabCoordinate = tabCoordinates[i][orientationSettings.to];

                if (currentCoordinate >= currentTabCoordinate - 4 && currentCoordinate <= currentTabCoordinate + 4) {
                    tabToResize = that._reorderItems[i];
                    that._resizeFrom = currentCoordinate;
                    break;
                }
            }

            if (tabToResize !== undefined) {
                that._tabToResize = tabToResize;
                that.setAttribute('resizing', '');
            } else {
                that._tabToResize = undefined;
                that.removeAttribute('resizing');
            }
        }

        /**
         * Toggles the collapsed state on click.
         */

    }, {
        key: '_toggleCollapsedState',
        value: function _toggleCollapsedState() {
            var that = this;

            if (!that.collapsible) {
                return;
            }

            if (!that.collapsed) {
                that.collapse();
            } else {
                that.expand();
            }
        }

        /**
         * Updates the selected index and the index of each tab.
         */

    }, {
        key: '_updateIndexes',
        value: function _updateIndexes(index) {
            var that = this;

            if (that.selectedIndex !== null && index <= that.selectedIndex) {
                that.selectedIndex++;
            }

            that._updateTabIndexes();
        }

        /**
         * Updates the indexes of all tabs.
         */

    }, {
        key: '_updateTabIndexes',
        value: function _updateTabIndexes() {
            var that = this;

            if (that._tabs.length > 0) {
                for (var i = 0; i < that._tabs.length; i++) {
                    that._tabs[i]._setIndex(i);
                }
            } else {
                that.selectedIndex = null;
            }
        }

        /**
         * Validates the index passed to the methods "ensureVisible", "insert", "remove", "select" and "update".
         */

    }, {
        key: '_validateIndex',
        value: function _validateIndex(index, method) {
            if (isNaN(parseInt(index, 10)) || (typeof index === 'undefined' ? 'undefined' : babelHelpers.typeof(index)) === 'object') {
                var that = this;

                that.error(that.localize('invalidIndex', { method: method }));
            }
        }

        /**
         * Validates the initial selection.
         */

    }, {
        key: '_validateInitialSelection',
        value: function _validateInitialSelection() {
            var that = this;
            var selectedIndex = that.selectedIndex;

            for (var i = 0; i < that._tabs.length; i++) {
                var currentTab = that._tabs[i];

                if (currentTab.selected) {
                    if (selectedIndex === null) {
                        selectedIndex = i;
                    } else {
                        currentTab.selected = false;
                        currentTab.$.addClass('jqx-hidden');
                    }
                } else if (selectedIndex === i) {
                    currentTab.selected = true;
                } else {
                    currentTab.$.addClass('jqx-hidden');
                }
            }

            if (that._tabs.length > 0 && selectedIndex === null) {
                selectedIndex = 0;

                that._tabs[0].selected = true;
            }

            that.selectedIndex = selectedIndex;
        }
    }], [{
        key: 'properties',

        // Tabs's properties.
        get: function get() {
            return {
                'addNewTab': {
                    value: false,
                    type: 'boolean'
                },
                'closeButtonMode': {
                    value: 'default',
                    allowedValues: ['default', 'selected'],
                    type: 'string'
                },
                'closeButtons': {
                    value: false,
                    type: 'boolean'
                },
                'collapsed': {
                    value: false,
                    type: 'boolean'
                },
                'collapsible': {
                    value: false,
                    type: 'boolean'
                },
                'messages': {
                    value: {
                        'en': {
                            'ambiguousIndexes': 'jqx-tabs: Initially set jqx-tab-item indexes are ambiguous and are ignored in favour of the HTML structure.',
                            'detailsObjectRequired': 'jqx-tabs: The method "insert" requires a details Object to be passed as a second argument.',
                            'invalidIndex': 'jqx-tabs: "{{method}}" method accepts an index of type number.',
                            'referenceNodeNotChild': 'jqx-tabs: Passed {{argument}} is not part of this jqx-tabs element.',
                            'tabItemRequired': 'jqx-tabs: The method "{{method}}" requires a "jqx-tab-item" element to be passed as an argument.'
                        }
                    },
                    type: 'object',
                    extend: true
                },
                'position': {
                    value: 'top',
                    allowedValues: ['top', 'bottom', 'left', 'right', 'hidden'],
                    type: 'string'
                },
                'readonly': {
                    value: false,
                    type: 'boolean'
                },
                'reorder': {
                    value: false,
                    type: 'boolean'
                },
                'resize': {
                    value: false,
                    type: 'boolean'
                },
                'scrollButtonsPosition': {
                    value: 'both',
                    allowedValues: ['near', 'far', 'both'],
                    type: 'string'
                },
                'selectedIndex': {
                    value: null,
                    type: 'number?'
                },
                'selectionMode': {
                    value: 'click',
                    allowedValues: ['click', 'dblclick', 'mouseenter', 'none'],
                    type: 'string'
                },
                'tabOverflow': {
                    value: 'scroll',
                    allowedValues: ['scroll', 'dropdown', 'wrap', 'shrink'],
                    type: 'string',
                    defaultReflectToAttribute: true
                },
                'textOrientation': {
                    value: 'horizontal',
                    allowedValues: ['horizontal', 'vertical'],
                    type: 'string'
                }
            };
        }

        /**
         * Tabs's event listeners.
         */

    }, {
        key: 'listeners',
        get: function get() {
            return {
                'closeButtonVisibilityChange': '_closeButtonVisibilityChangeHandler',
                'indexChange': '_indexChangeHandler',
                'keydown': '_keydownHandler',
                'labelSizeChange': '_labelSizeChangeHandler',
                'resize': '_applyTabOverflow',
                'styleChanged': '_applyTabOverflow',
                'container.dblclick': '_containerHandler',
                'container.down': '_containerHandler',
                'container.mouseout': '_containerHandler',
                'container.mouseover': '_containerHandler',
                'container.up': '_containerHandler',
                'scrollButtonFar.click': '_scrollButtonFarClickHandler',
                'scrollButtonNear.click': '_scrollButtonNearClickHandler',
                'tabStrip.mouseleave': '_tabStripMouseleaveHandler',
                'tabStrip.move': '_tabStripMoveHandler',
                'document.move': '_documentMoveHandler',
                'document.selectstart': '_selectStartHandler',
                'document.up': '_documentUpHandler'
            };
        }
    }]);
    return Tabs;
}(JQX.BaseElement));